import argentina from '../assets/flags/argentina.webp'
import chile from '../assets/flags/chile.webp'
import ecuador from '../assets/flags/ecuador.webp'
import guatemala from '../assets/flags/guatemala.webp'
import mexico from '../assets/flags/mexico.webp'
import panama from '../assets/flags/panama.webp'
import paraguay from '../assets/flags/paraguay.webp'
import { COUNTRY_CODE } from './config'
import { AR, CL, EC, GT, MX, PA, PY } from './regions-and-cities'

export type CountryCode = 'AR' | 'CL' | 'EC' | 'GT' | 'MX' | 'PA' | 'PY'

export type MXStates = { id: string; label: string }[]

export type RegionsAndStates = { [key: string]: string[] }

type CountryInfo = {
  name: string
  zhName: string
  email: string
  flag: string
  regionsAndCities: MXStates | RegionsAndStates
  phoneCountryCode: string
  forms: {
    specificFields?: string[]
    phoneLength: number
    ruc?: {
      [key in string]: string | number
    }
    postalCodeLength: number
  }
  gift?: number
  referralProgram?: {
    amount?: string
    timezone?: string
  }
}

export const COUNTRY_CODE_MAP: Record<CountryCode, CountryCode> = Object.freeze({
  'AR': 'AR',
  'CL': 'CL',
  'EC': 'EC',
  'GT': 'GT',
  'MX': 'MX',
  'PA': 'PA',
  'PY': 'PY',
})

const COUNTRIES: Record<CountryCode, CountryInfo> = {
  AR: {
    name: 'Argentina',
    zhName: '阿根廷',
    email: 'soporte.ar@fun88.com',
    flag: argentina,
    regionsAndCities: AR,
    phoneCountryCode: '+54',
    forms: {
      phoneLength: 10,
      specificFields: ['dni'],
      postalCodeLength: 4,
    },
  },
  CL: {
    name: 'Chile',
    zhName: '智利',
    email: 'soporte@fun88chile.com',
    flag: chile,
    regionsAndCities: CL,
    phoneCountryCode: '+56',
    forms: {
      phoneLength: 9,
      specificFields: ['rut'],
      postalCodeLength: 7,
    },
    referralProgram: {
      amount: '$10,000',
    },
  },
  EC: {
    name: 'Ecuador',
    zhName: '厄瓜多尔',
    email: 'soporte.ec@fun88.com',
    flag: ecuador,
    regionsAndCities: EC,
    phoneCountryCode: '+593',
    forms: {
      phoneLength: 7,
      specificFields: ['nui'],
      postalCodeLength: 6,
    },
    gift: 5,
    referralProgram: {
      amount: '$10',
      timezone: '-5',
    },
  },
  GT: {
    name: 'Guatemala',
    zhName: '危地马拉',
    email: 'soporte@fun88guatemala.com',
    flag: guatemala,
    regionsAndCities: GT,
    phoneCountryCode: '+502',
    forms: {
      phoneLength: 8,
      specificFields: ['cui'],
      postalCodeLength: 5,
    },
  },
  MX: {
    name: 'Mexico',
    zhName: '墨西哥',
    email: 'soporte@fun88.mx',
    flag: mexico,
    regionsAndCities: MX,
    phoneCountryCode: '+52',
    forms: {
      phoneLength: 10,
      postalCodeLength: 5,
    },
  },
  PA: {
    name: 'Panama',
    zhName: '巴拿马',
    email: 'soporte@fun88panama.com',
    flag: panama,
    regionsAndCities: PA,
    phoneCountryCode: '+507',
    forms: {
      phoneLength: 8,
      specificFields: ['ruc'],
      ruc: {
        length: 13,
        placeholder: '1-234-567, 1-234-567-89, 1-234-5678-90',
      },
      postalCodeLength: 4,
    },
  },
  PY: {
    name: 'Paraguay',
    zhName: '巴拉圭',
    email: 'soporte@fun88paraguay.com',
    flag: paraguay,
    regionsAndCities: PY,
    phoneCountryCode: '+595',
    forms: {
      phoneLength: 9,
      specificFields: ['ruc'],
      ruc: {
        length: 8,
        placeholder: '12345678',
      },
      postalCodeLength: 4,
    },
  },
}

// Exporting current country data
export const COUNTRY_NAME = COUNTRIES[COUNTRY_CODE].name
export const ZH_COUNTRY_NAME = COUNTRIES[COUNTRY_CODE].zhName
export const COUNTRY_EMAIL = COUNTRIES[COUNTRY_CODE].email
export const COUNTRY_FLAG = COUNTRIES[COUNTRY_CODE].flag
export const COUNTRY_REGIONS_AND_CITIES =
  COUNTRIES[COUNTRY_CODE].regionsAndCities
export const PHONE_COUNTRY_CODE = COUNTRIES[COUNTRY_CODE].phoneCountryCode
export const COUNTRY_FORM = COUNTRIES[COUNTRY_CODE].forms
export const COUNTRY_GIFT = COUNTRIES[COUNTRY_CODE].gift
export const COUNTRY_REFERRAL_PROGRAM = COUNTRIES[COUNTRY_CODE].referralProgram
